import type {GroupBase} from "react-select";

import type {OptionType} from "./Select";

export const isGroupOption = (
    options: OptionType[] | GroupBase<OptionType>[]
): options is GroupBase<OptionType>[] => {
    return options?.length > 0 && "options" in options[0];
};
